// Headless export registration for Emotional Dial (hybrid composite, single-output).
// The live EmotionalDialChart is reused as-is; its own useExportableChart builds the
// composite (HC line + timeslice capsule OR windmap canvas + heatmap mask) and the
// nested ChartContainer attachment is parked via exportDelegated. Key `emd` is the
// legacy pptx.coffee dispatch key (Option A). The report-param `emd{key}` is
// {viewMode, lineMode, videoTime} (null → defaults) — the driver forwards the three
// fields as params; defaults mirror legacy lib.coffee (windmap / precise / 0).
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/09-emd.md

import {
  ExportableCharts,
  type ExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

import EmdChart from '@aytm/app/stats/page/question-views/emd/components/chart/Chart'

// RenderShell's fixed export canvas (same constant as RenderShell.tsx).
const EXPORT_WIDTH = 746
// Legacy EmotionalDial.ChartView hard-codes @axisHeight = 555.
const EMD_HEIGHT = 555
// Chart wrapper paddingRight — legacy passes page.model.width() - 12. The
// width prop must equal ChartContainer's measured width (canvas minus padding) or
// the Heatmap/Windmap overlays misalign with the HC plot box.
const WRAPPER_PADDING = 12

const emdEntry: ExportableChart = {
  Component: EmdChart,
  toProps: (data: any, params: any) => ({
    questionKey: data.questionKey,
    qType: data.qType || 'emd',
    // Drives the batch-gradient-{id}-{i} / outline-{id}-{i} defs ids + heatmap mask id.
    questionId: String(data.id ?? data.questionKey),
    viewMode: params.viewMode || 'windmap',
    lineMode: params.lineMode || 'precise',
    // Snapped to the nearest pointDensity time by the chart's resolvedVideoTime.
    videoTime: params.videoTime ?? 0,
    answer: data.answer,
    batches: data.batches,
    width: (Number(params.width) || EXPORT_WIDTH) - WRAPPER_PADDING,
    height: Number(params.height) || EMD_HEIGHT,
    videoDuration: data.videoDuration ?? 0,
    playing: false,
    colorTheme: data.colorTheme,
    features: data.features || {},
    // Interactive callbacks stay undefined in headless.
    onTimeUpdate: undefined,
    onPlayingEnd: undefined
  })
}

ExportableCharts.register('emd', emdEntry)
